import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import useAacFlags from "hooks/useAacFlags";
import { AccountContext } from "views/AccountWrapper";
import { Policy, SpaceAccessLevel } from "types/generated";
import { hasSpaceAccessAtLeast } from "utils/user";
import { hasAtLeastReadAccess } from "utils/access";

const useCanReadPolicy = (): ((policy?: Pick<Policy, "space" | "spaceDetails">) => boolean) => {
  const { viewer } = useTypedContext(AccountContext);
  const { customAccessRoles } = useAacFlags();

  return useCallback(
    (policy?: Pick<Policy, "space" | "spaceDetails">) => {
      if (!policy) {
        return false;
      }

      if (viewer.admin) {
        return true;
      }

      // TODO: remove this once we have a proper type for the spaceDetails in query results
      if (customAccessRoles) {
        return hasAtLeastReadAccess(viewer, policy.space || policy.spaceDetails?.id);
      }

      return hasSpaceAccessAtLeast(policy.spaceDetails?.accessLevel, SpaceAccessLevel.Read);
    },
    [customAccessRoles, viewer]
  );
};

export default useCanReadPolicy;
